import { Logo, LogoIcon, TextLogo, LogoWordmark } from './Logo';
import { AnimatedLogo, AnimatedLogoIcon, LoadingLogo } from './AnimatedLogo';
import { Card } from './ui/card';
import { FestiveDecoration, FestiveDivider, FestiveCorner } from './FestiveDecoration';

export function DesignShowcase() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-secondary/30 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <Card className="p-8 mb-8">
          <h1 className="text-4xl mb-4">BtGtR Design System Showcase</h1>
          <p className="text-muted-foreground">
            Explore the festive color palette and component designs for Better to Give than Receive
          </p>
        </Card>

        {/* Logo Showcase */}
        <Card className="p-8 mb-8">
          <h2 className="text-2xl mb-6">Logo Variations</h2>
          
          <div className="space-y-8">
            <div>
              <h3 className="text-lg mb-4">Full Logo</h3>
              <div className="bg-white p-8 rounded-lg border-2">
                <Logo size="lg" />
              </div>
            </div>

            <div>
              <h3 className="text-lg mb-4">Logo Icon Only</h3>
              <div className="bg-white p-8 rounded-lg border-2 flex gap-8">
                <LogoIcon size="sm" />
                <LogoIcon size="md" />
                <LogoIcon size="lg" />
              </div>
            </div>

            <div>
              <h3 className="text-lg mb-4">Animated Variants</h3>
              <div className="bg-white p-8 rounded-lg border-2 flex gap-8 items-center">
                <AnimatedLogo size="md" />
                <AnimatedLogoIcon size="md" />
                <LoadingLogo />
              </div>
            </div>

            <div>
              <h3 className="text-lg mb-4">Text Logo & Wordmark</h3>
              <div className="bg-white p-8 rounded-lg border-2 space-y-4">
                <TextLogo className="text-xl" />
                <LogoWordmark size="md" />
              </div>
            </div>
          </div>
        </Card>

        {/* Festive Decorations */}
        <Card className="p-8 mb-8">
          <h2 className="text-2xl mb-6">Festive Decorations</h2>
          <div className="relative bg-white p-12 rounded-lg border-2 min-h-[300px]">
            <FestiveDecoration variant="snowflakes" position="top-left" />
            <FestiveDecoration variant="gifts" position="bottom-right" />
            <FestiveCorner corner="top-left" />
            <FestiveCorner corner="bottom-right" />
            <div className="text-center">
              <p className="text-muted-foreground">Decorative elements add festive charm</p>
            </div>
            <FestiveDivider className="my-8" />
          </div>
        </Card>

        {/* Color Palette */}
        <Card className="p-8">
          <h2 className="text-2xl mb-6">Festive Color Palette</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="space-y-2">
              <div className="bg-primary h-24 rounded-lg border-2"></div>
              <p className="font-medium">Forest Green</p>
              <p className="text-xs text-muted-foreground">Primary</p>
            </div>
            <div className="space-y-2">
              <div className="bg-destructive h-24 rounded-lg border-2"></div>
              <p className="font-medium">Deep Red</p>
              <p className="text-xs text-muted-foreground">Destructive/Accent</p>
            </div>
            <div className="space-y-2">
              <div className="bg-accent h-24 rounded-lg border-2"></div>
              <p className="font-medium">Gold/Orange</p>
              <p className="text-xs text-muted-foreground">Accent</p>
            </div>
            <div className="space-y-2">
              <div className="bg-secondary h-24 rounded-lg border-2"></div>
              <p className="font-medium">Warm Beige</p>
              <p className="text-xs text-muted-foreground">Secondary</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
